<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<!-- 搜索筛选 -->
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="getListData()">
			<template #query>
				<el-button size="small" type="primary" icon="el-icon-search" @click="getListData()">搜索</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable @change="getListData">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="统计时间：">
					<el-date-picker
						v-model="inputDate"
						:type="statisticType"
						:default-value="new Date()"
						:clearable="false"
						:value-format="statisticType === 'month' ? 'yyyy-MM' : 'yyyy'"
						:placeholder="statisticType === 'month' ? '选择月' : '选择年'"
						:editable="false"
						:format="statisticType === 'month' ? 'yyyy年MM月' : 'yyyy年'"
						size="small"
						@change="changeDate"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="统计类型：">
					<el-radio-group v-model="statisticType" size="small" @change="handleChangeStatisticType">
						<el-radio label="month" selected>月统计</el-radio>
						<el-radio label="year">年统计</el-radio>
					</el-radio-group>
				</el-form-item>
			</lcsj-filter>
			<!--列表：容器吃掉剩余高度，高度实测后传给表格，避免底部（总计行）被遮挡-->
			<div ref="tableWrap" class="table-wrap">
				<STable
					ref="table"
					:columns="columnsData"
					:data="listData"
					:loading="loading"
					border
					stripe
					:row-key="'rowNumber'"
					:height="tableHeight"
					@get-data="getListData"
				>
					<!-- ⑦⑧⑨ 表头分两行（标题 + 计算公式）：el-table 的 .cell 是 white-space: normal，
					     字符串里的 \r\n / &#10; 会被折叠成空格，必须用 #header 插槽渲染成两个块级元素 -->
					<template #afterSaleTotal>
						<el-table-column align="center" label="⑦售后总数量" width="150">
							<template #header>
								<div class="th-title">⑦售后总数量</div>
								<div class="th-formula">⑦=④+⑥</div>
							</template>
							<template #default="scope">{{ scope.row.afterSalesTotalCount }}</template>
						</el-table-column>
					</template>
					<template #realCount>
						<el-table-column align="center" label="⑧实际数量" width="170">
							<template #header>
								<div class="th-title">⑧实际数量</div>
								<div class="th-formula">⑧=②-④-⑤</div>
							</template>
							<template #default="scope">{{ scope.row.realCount }}</template>
						</el-table-column>
					</template>
					<template #afterSaleRate>
						<el-table-column align="center" label="⑨售后率" width="150">
							<template #header>
								<div class="th-title">⑨售后率</div>
								<div class="th-formula">⑨=⑦/⑧×100%</div>
							</template>
							<template #default="scope">{{ scope.row.afterSaleRate }}%</template>
						</el-table-column>
					</template>
				</STable>
			</div>
		</topTab>
	</div>
</template>

<script>
import { GeyAfterSaleOrderStatistic } from "@/api/storeOrderApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "售后统计"
				}
			],
			loading: false, // 显示加载
			formInline: {
				storeKeyId: "",
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1
			},
			listData: [],
			statisticType: "month",
			inputDate: new Date(),
			storeList: [],
			columnsData: [], //显示列
			// 表格高度（数字 px）。el-table 只有拿到数字高度才会内部竖滚；
			// 该值由 calcTableHeight 实测容器剩余空间后填入，与视口固定值无关。
			tableHeight: 520,
			ro: null, // ResizeObserver 句柄
			pd20El: null, // topTab 内容区(.pd20) 元素引用，销毁时还原其高度
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60"
				},
				{
					prop: "storeCode",
					label: "门店编号",
					align: "center",
					width: "80"
				},
				{
					prop: "storeName",
					label: "所属门店",
					align: "center",
					minWidth: 120
				},
				{
					prop: "totalCount",
					label: "①创建订单总数量",
					align: "center",
					minWidth: 110
				},
				{
					prop: "kdCount",
					label: "②快递订单数量",
					align: "center",
					minWidth: 110
				},
				{
					prop: "cheDanCount",
					label: "③撤单数量",
					align: "center",
					minWidth: 110
				},
				{
					prop: "afterSaleCount",
					label: "④售后数量",
					align: "center",
					minWidth: 110
				},
				{
					prop: "waiJiaGongCount",
					label: "⑤外加工数量",
					align: "center",
					minWidth: 110
				},
				{
					prop: "reWarehouseCount",
					label: "⑥重新出库数量",
					align: "center",
					minWidth: 110
				},
				{
					slot: "afterSaleTotal",
					label: "⑦售后总数量",
					align: "center"
				},
				{
					slot: "realCount",
					label: "⑧实际数量",
					align: "center"
				},
				{
					slot: "afterSaleRate",
					label: "⑨售后率",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {},
	/**
	 * 创建完毕
	 */
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.getListData();
	},
	mounted() {
		this.$nextTick(() => {
			this.syncContentHeight();
			this.calcTableHeight();
			// 内容区尺寸变化（侧边栏收起、窗口缩放等）时重算表格高度，保证总计行完整可见
			if (typeof ResizeObserver !== "undefined") {
				const pd20 = this.getContentBox();
				if (pd20) {
					this.ro = new ResizeObserver(() => this.calcTableHeight());
					this.ro.observe(pd20);
				}
			}
		});
		window.addEventListener("resize", this.handleViewportResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleViewportResize);
		if (this.ro) {
			this.ro.disconnect();
			this.ro = null;
		}
		// 还原注入到 topTab 内容区的行内高度，避免影响组件后续复用
		if (this.pd20El) {
			this.pd20El.style.height = "";
			this.pd20El = null;
		}
	},
	computed: {},
	/**
	 * 里面的方法只有被调用才会执行
	 */
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// topTab 内容区(.pd20) 元素
		getContentBox() {
			const root = this.$refs.topTab && this.$refs.topTab.$el;
			return root ? root.querySelector(".pd20") : null;
		},
		// 修正 topTab 内容区的高度基准（本页面根因所在）：
		//   topTab.vue 里写死 height: calc(100vh - 130px)，与当前布局顶部实际占位(约 178px)不符，
		//   且 .pd20 是 content-box（padding-bottom 16px 还会再叠加）⇒ 内容区底边比视口底低约 60px，
		//   被 #app{overflow:hidden} 裁掉且滚不到，表现为「表格底部/总计行被遮挡」。
		//   这里实测内容区顶部偏移后重设其高度，使内容区底边落在视口底；只改本页面实例，不动组件的 scoped 样式。
		syncContentHeight() {
			const pd20 = this.getContentBox();
			if (!pd20) return;
			this.pd20El = pd20;
			// 累计 offsetTop 得到内容区相对文档顶部的偏移（不受内容区/外层滚动影响）
			let top = 0;
			let el = pd20;
			while (el) {
				top += el.offsetTop || 0;
				el = el.offsetParent;
			}
			// 护栏：测量值明显异常时保持 topTab 原样式，避免反而把内容区撑得更高
			if (top < 60 || top > window.innerHeight / 2) return;
			const padBottom = parseFloat(window.getComputedStyle(pd20).paddingBottom) || 0;
			pd20.style.height = `calc(100vh - ${top + padBottom}px)`;
		},
		handleViewportResize() {
			this.syncContentHeight();
			this.calcTableHeight();
		},
		// 动态计算表格高度（实测剩余空间，数字 px）：
		// .pd20 为 flex 纵向容器、表单 flex-shrink:0 固定，表格容器 flex:1 吃掉剩余像素，
		// 量出后传给 el-table 触发内部竖滚，于是内容区自身不出现滚动条、底部行不会被裁切。
		calcTableHeight() {
			this.$nextTick(() => {
				const wrap = this.$refs.tableWrap;
				if (!wrap) return;
				// 兜底：万一内容区高度基准未修正成功，按「表格容器顶边到视口底的可视余量」再压一次
				const viewportAvail = window.innerHeight - wrap.getBoundingClientRect().top - 16;
				const wrapH = viewportAvail > 0 ? Math.min(wrap.clientHeight, viewportAvail) : wrap.clientHeight;
				this.tableHeight = Math.max(wrapH, 200);
			});
		},
		changePages() {},
		changeDate(val) {
			var list = val.split("-");
			if (this.statisticType === "month") {
				this.formInline.year = parseInt(list[0]);
				this.formInline.month = parseInt(list[1]);
			} else {
				this.formInline.year = parseInt(list[0]);
				this.formInline.month = 0;
			}
			this.getListData();
		},
		handleChangeStatisticType(val) {
			if (val === "month") {
				this.formInline.year = new Date().getFullYear();
				this.formInline.month = new Date().getMonth() + 1;
			} else {
				this.formInline.year = new Date().getFullYear();
				this.formInline.month = 0;
			}
			this.getListData();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GeyAfterSaleOrderStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.listData = res.data;
						// 数据回来后表格形态稳定，重算一次高度并强制 el-table 重排
						this.$nextTick(() => {
							this.calcTableHeight();
							if (this.$refs.table && this.$refs.table.doLayoutTable) {
								this.$refs.table.doLayoutTable();
							}
						});
					} else {
						this.$message({
							type: "info",
							message: "暂无数据"
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取门店信息失败!");
				});
		}
	}
};
</script>

<style scoped lang="scss">
/* 表单固定高不参与压缩 */
.user-search {
	flex-shrink: 0;
	margin-bottom: 10px;
}
/* 表格容器吃掉 topTab 内容区剩余高度，超出交给 el-table 内部滚动 */
.table-wrap {
	flex: 1;
	min-height: 0;
	overflow: hidden;
}
/* 表头两行：第一行标题，第二行计算公式（次要信息，弱化显示） */
.th-title {
	line-height: 16px;
}
.th-formula {
	line-height: 16px;
	font-size: 11px;
	font-weight: 400;
	color: var(--app-text-muted);
}
</style>
